import getFirstNode from './getFirstNode';

export default (adsConfig, navigate) => {
  const { region } =
    JSON.parse(localStorage.getItem('startHeaderInfoResponse'))?.response || {};

  const enable = adsConfig?.enable;
  const regionEnable = adsConfig?.[region]?.enable;
  const defaultEnable = adsConfig?.default?.enable;

  const claroAdEnable = enable || regionEnable || defaultEnable || false;

  const firstNode = getFirstNode(claroAdEnable);

  const userData = JSON.parse(
    localStorage.getItem('loginInfo.logged_user_data'),
  );

  let pageToRedirect = '';
  if (userData) {
    pageToRedirect = firstNode;
  } else {
    pageToRedirect = claroAdEnable ? firstNode : 'landing';
  }

  navigate(`/${region}/${pageToRedirect}`);
};
